var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b{fill:#353841;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.285 26.068)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.25,22.572H28.212a.787.787,0,0,1-.787-.787v-1.9H25.553l.227,0c-.144-3.277-2.413-3.586-2.435-3.588s-4.252-.011-7.66-.011c-2.018,0-3.387,0-4.069.011-2.172.02-2.46,3.226-2.486,3.592H7.507v1.9a.787.787,0,0,1-.787.787H3.683a.787.787,0,0,1-.787-.787V10.972A1.627,1.627,0,0,1,4.057,9.406l0-.013V9.38c0-.035,0-.065,0-.093H.864a.707.707,0,0,1-.623-.43,3.144,3.144,0,0,1,0-2.421.707.707,0,0,1,.623-.43H4.056a.705.705,0,0,1,.623.43,4.428,4.428,0,0,1,.221.881C6.1,5.017,7.459,2.378,7.849,1.624l.01-.019A1.273,1.273,0,0,1,8.828.784a47.991,47.991,0,0,1,17.277,0,1.273,1.273,0,0,1,.968.821c0,.006.072.141.189.365l.009.019.4.778c.6,1.153,1.5,2.895,2.359,4.55a4.331,4.331,0,0,1,.221-.881.707.707,0,0,1,.623-.43h3.192a.705.705,0,0,1,.623.43,3.144,3.144,0,0,1,0,2.421.708.708,0,0,1-.624.43H30.883c0,.048,0,.085-.007.119a1.628,1.628,0,0,1,1.161,1.566V21.785A.787.787,0,0,1,31.25,22.572ZM27.319,11.416a14.54,14.54,0,0,0-2.459.267c-1.552.168-1.825,2.382-1.827,2.4h5.733c.009-.018.956-1.815,0-2.4A2.914,2.914,0,0,0,27.319,11.416Zm-19.443,0a2.911,2.911,0,0,0-1.446.267c-.961.591-.01,2.386,0,2.4h5.733c0-.021-.269-2.235-1.827-2.4A14.478,14.478,0,0,0,7.876,11.416Zm9.566-9.767a52.556,52.556,0,0,0-7.753.671H9.684L6.613,8.778H28.271L25.263,2.321A54.05,54.05,0,0,0,17.442,1.649Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1531.957,7869.749s.178-2.8,1.833-2.84,11.544,0,11.544,0,1.667.23,1.8,2.84C1544.921,7869.767,1531.957,7869.749,1531.957,7869.749Z",
    transform: "translate(-1522.089 -7849.912)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.0b4698386d5f566aa87836872905ea37.svg";
export { ForwardRef as ReactComponent };